
import { defineComponent } from '@vue/runtime-core'

export default defineComponent({
  name: 'HospitalLabel',

  props: {
    items: {
      type: Array,
      default: () => []
    },
    isLarge: {
      type: Boolean,
      default: false
    },
    isOnline: {
      type: Boolean,
      default: false
    }
  }
})
